<template>
  <div class="header">
    <div class="head-top">
      <a class="head-back" @click.prevent="goBack"></a>
      <h1 class="head-title">智慧城市云网</h1>
    </div>
    <div class="head-bot">
      <div class="flex">
        <div @click="gotoHome" class="yi-fl head-logo">
          <img src="../assets/logo@2x.png" alt="">
        </div>
        <div class="yi-fl head-img">
          <img src="../assets/header/desc.png" alt="">
        </div>
      </div>
      <div class="flex" v-if="isLogin">
        <div class="yi-fl head-select">
          <select v-model="searchType">
            <option value="1">项目</option>
            <option value="2">机构</option>
            <option value="3">产品</option>
            <option value="4">服务</option>
            <option value="5">专家</option>
            <option value="6">政策</option>
            <option value="7">标准</option>
          </select>
        </div>
        <div class="yi-fl head-search">
          <input v-model="keyword" class="yi-fl sec-ipt" type="text" placeholder="发起搜索请求" />
          <a @click.prevent="onSearch" class="yi-fr sec-btn">搜索</a>
        </div>
      </div>
      <div>
       <!--vip入口 <div class="vip">
          <div slot="reference" class="yi-fl" @click.prevent="onVip">
            <img src="../assets/main/vip.svg" alt="">
          </div>
        </div> -->
        <div class="yi-fr head-account flex">
          <div v-if="!isLogin && hasLogined" @click="onLogin" class="head-me head-me-pc">我的</div>
          <div slot="reference" class="yi-fl head-login">
            <a v-show="!hasLogined" @click.prevent="onLogin" class="acc-link">登录</a>
          </div>
          <el-popover v-if="hasLogined" placement="bottom-end" width="200" trigger="click">
            <div>
              <ul>
                <li @click.prevent="onPersonalCenter" class="c-s-logout__item">控制台</li>
                <li @click.prevent="onLogout" class="c-s-logout__item">退出登录</li>
              </ul>
            </div>
            <div slot="reference" class="yi-fl head-login">
              <!-- <a v-show="!hasLogined" @click.prevent="onLogin" class="acc-link">登录</a> -->
              <span v-show="hasLogined && isLogin" class="acc-link head-account__name">{{account}}</span>
              <span v-show="hasLogined && !isLogin" class="acc-link head-account__name">我的</span>
            </div>
          </el-popover>
          <!-- <div class="yi-fl head-login" @click="onHeadLoginClick">
            <a v-show="!hasLogined" @click.prevent="onLogin" class="acc-link">登录</a>
            <span v-show="hasLogined" class="acc-link head-account__name">{{account}}</span>
          </div> -->
          <span v-if="isLogin" class="yi-fl hrx"></span>
          <div v-if="isLogin" class="yi-fl head-reg">
            <a @click.prevent="onRegister" class="acc-link">注册</a>
          </div>
          <!-- <span v-if="isLogin" class="yi-fl hrx"></span> -->
          <!-- <div v-if="isLogin" class="yi-fl head-reg">
            <a @click.prevent="onPersonalCenter" class="acc-link">个人中心</a>
          </div> -->
          <div class="head-logout">

          </div>
        </div>
      </div>

    </div>
    <Nav v-if="showNav"/>
  </div>
</template>

<script>
import {
  Popover,
  Button
} from 'element-ui';
import {
  mobilecheck
} from '@/utils/ua'
import {
  logout
} from "@/api/login.js"
import {
  removeToken,getToken
} from '@/utils/auth.js'
import Nav from '@/components/Nav.vue';

export default {
  name: 'Header',
  props: {
    msg: String,
    isLogin: Boolean,
    showNav: {
      type: Boolean,
      default:true
    }
  },
  components: {
    [Popover.name]: Popover,
    [Button.name]: Button,
    Nav,
  },
  data() {
    return {
      keyword: '',
      account: '',
      hasLogined: false,
      searchType:1
    }
  },
  mounted() {
    this.hasLogin();
  },
  methods: {
    goBack() {
      this.$router.back(-1)
    },
    onLogout() {
      let tokenstr = getToken()
      this.$http.post(logout(), {
        token: tokenstr.split(" ")[1],
      }).then(res => {

      })
      window.localStorage.removeItem('userInfo');
      removeToken()
      window.location.reload();
    },
    hasLogin() {
      const userInfoStr = window.localStorage.getItem('userInfo');
      const userInfo = userInfoStr && JSON.parse(userInfoStr);
      if (userInfo && userInfo.account) {
        this.account = userInfo.account;
        this.hasLogined = true;
      }
    },
    onSearch() {
      console.log("this.searchType",this.searchType)
      var kw = encodeURI(this.keyword)
      if(this.searchType==1){
        this.$router.push(`/project-find?keyword=${kw}`)
      }else if(this.searchType==2){
        this.$router.push(`/organization?keyword=${kw}`)
      }else if(this.searchType==3){
        this.$router.push(`/product?keyword=${kw}`)
      }else if(this.searchType==4){
        this.$router.push(`/service?keyword=${kw}`)
      }else if(this.searchType==5){
        this.$router.push(`/specialist?keyword=${kw}`)
      }else if(this.searchType==6){
        this.$router.push(`/policy?keyword=${kw}`)
      }else if(this.searchType==7){
        this.$router.push(`/standard?keyword=${kw}`)
      }
    },
    onLogin() {
      if (this.hasLogined) {
        this.$router.push('/personal-center/m-mine');
        return;
      }
      this.$router.push('/login');
    },
    onRegister() {
      this.$router.push('/register');
    },
    gotoHome() {
      this.$router.push('/');
    },
    onPersonalCenter() {
      if (mobilecheck()) {
        this.$router.push('/personal-center/m-mine');
        return;
      }
      this.$router.push('/personal-center/profile');
    },
    onVip() {
      this.$router.push('/vip');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url(./Header.css);

  .head-login {
    cursor: pointer;
  }

  .c-s-logout__item {
    height: .5rem;
    padding: .15rem 0;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
  }

  .c-s-logout__item:hover {
    background: #EDEBEB;
  }

  .vip {
    display: inline-block;
    color: #fff;
    line-height: 0.36rem;
    vertical-align: middle;
  }

  body.h5Style .head-me-pc {
    display: none;
  }

  body.h5Style .vip {
    margin-right: 20px;
  }
</style>
